<template>
	<el-form :model="form" ref='form' :rules="rules">
		<el-form-item label="菜单类型" prop="type">
		    <el-radio-group v-model="form.type" size="mini" style="width: 178px">
		        <el-radio-button label="1">目录</el-radio-button>
		        <el-radio-button label="2">菜单</el-radio-button>
		    </el-radio-group>
		</el-form-item>
		<el-form-item  label="菜单标题" prop="title">
		          <el-input v-model="form.title" style="width: 178px;" placeholder="菜单标题" clearable/>
		</el-form-item>
		<el-form-item v-show="form.type.toString() === '2'"  label="菜单地址" prop="path">
		          <el-input v-model="form.path" style="width: 178px;" placeholder="菜单地址" clearable/>
				  <el-tooltip  content="填写菜单的url,例如:/main/xxxx" placement="top">
				  	<i class="el-icon-info cs-ml-10" style="margin-left: 10px;"/>
				  </el-tooltip>
		</el-form-item>
		<el-form-item v-show="form.type.toString() === '2'"  label="路由地址" prop="api_path">
		          <el-input v-model="form.api_path" style="width: 178px;" placeholder="路由地址" clearable/>
				  <el-tooltip  content="填写菜单的路由地址,例如:/admin/控制器/方法.非必填" placement="top">
				  	<i class="el-icon-info cs-ml-10" style="margin-left: 10px;"/>
				  </el-tooltip>
		</el-form-item>
		<el-form-item v-show="form.type.toString() === '2'"  label="上级类目" prop="pid">
			<el-cascader
				v-model="form.pid"
				style="width: 178px;"
			    :options="options"
			    :props="props"
			    clearable>
			</el-cascader>
		</el-form-item>
		<el-form-item >
				  <span class="dialog-footer">
				    <el-button type="primary" @click="submit()">确 定</el-button>
				  </span>
		</el-form-item>
	</el-form>	

</template>

<script>
	export default{
		name:'MenuEdit',
		data(){
			return{
				props:{ checkStrictly: true,value:'id',label:'title',children:'all_children' },
				options:[],
				form:{
					type:1,
					title:'',
					path:'',
					api_path:'',
					pid:'',
				},
				rules:{
					title:[{
						required: true,
						message: '菜单标题不能为空',
						trigger: 'blur'
					}],
					path:[{
						required: true,
						message: '菜单地址不能为空',
						trigger: 'blur'
					}],
					api_path:[{
						required: true,
						message: '路由地址不能为空',
						trigger: 'blur'
					}],
					pid:[{
						required: true,
						message: '上级类目必选',
						trigger: 'change'
					}],
				}
			}
		},
		methods:{
			getMenu(){
				this.httpPost({
					url:'/admin/menu/menu_list'
				}).then((res)=>{
					this.options=res.data;
				})
			},
			getDetail(){
				this.httpPost({
					url:'/admin/menu/getDetail',
					data:{id:this.form.id}
				}).then((res)=>{
					this.setItem(this.form,res.data);
				})
				
			},
			submit(){
				if(this.form.type ==1){
					this.$refs['form'].validateField('title',(valid)=>{
						if(valid){
							console.log('error submit!')
							return false;
						}else{
							this.updateMenu();
						}
					})
				}else if(this.form.type ==2){
					this.$refs['form'].validate((valid)=>{
						if(valid){
							this.updateMenu();
						}else{
							console.log('error submit!')
							return false;
						}
					})
				}
			},
			updateMenu(){
				let temp = this.cloneObj(this.form);
							
				delete temp.re_password;
							
				let id = this.$route.query.id;
							
				console.log(id);
							
				if (!id) id = '';
							
							
				this.msgBoxAjax(
				  '提示',
				  '确定修改吗？',
				  "/admin/menu/menu_update?id=" + id,
				  temp).then((data) => {
				  // console.log(data);
							
				  if (data.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.$router.go(-1);
				    });
				  }else{
							
				    this.messageCommon('错误',data.msg,'error');
				  }
							
							
				});
			},
		},
		created() {
			this.getMenu();
			this.form.id = this.$route.query.id;
			if (this.form.id) this.getDetail();
		}
	}
</script>

<style>
</style>
